import { useState } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { sendContact } from "../lib/api";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } },
};

export const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      toast.error("Compila tutti i campi.");
      return;
    }
    setLoading(true);
    try {
      await sendContact(form);
      toast.success("Messaggio inviato! Ti risponderemo presto.");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Errore nell'invio. Riprova.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-transparent border border-white/20 px-4 py-4 text-[#E8E2D2] focus:border-[#D47738] focus:outline-none transition-colors";

  return (
    <section id="contatti" className="py-24 md:py-32 bg-[#141A14] border-t border-white/10" data-testid="contact-section">
      <div className="max-w-[1000px] mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
        <motion.div variants={reveal} initial={false} whileInView="visible" viewport={{ once: true, margin: "-80px" }}>
          <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#D47738] mb-6">Contatti</p>
          <h2 className="font-serif-display text-4xl md:text-6xl leading-[0.95] text-[#E8E2D2] mb-6">
            Scrivici <span className="italic text-[#D47738]">due righe</span>
          </h2>
          <p className="text-[#E8E2D2]/60 leading-relaxed mb-8">
            Domande sulle birre, ordini all'ingrosso o solo voglia di fare due chiacchiere? Compila il form e ti risponderemo al più presto.
          </p>
        </motion.div>

        <motion.form
          onSubmit={submit}
          variants={reveal}
          initial={false}
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          className="space-y-4"
          data-testid="contact-form"
        >
          <input placeholder="Il tuo nome" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inputCls} data-testid="contact-name" />
          <input type="email" placeholder="La tua email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={inputCls} data-testid="contact-email" />
          <textarea placeholder="Il tuo messaggio" rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className={inputCls + " resize-none"} data-testid="contact-message" />
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#D47738] text-[#0D110D] py-4 font-mono-accent text-xs uppercase tracking-[0.2em] hover:bg-[#E8E2D2] transition-colors duration-300 disabled:opacity-50"
            data-testid="contact-submit"
          >
            {loading ? "Invio..." : "Invia richiesta"}
          </button>
        </motion.form>
      </div>
    </section>
  );
};
